module.exports = __webpack_public_path__ + "assets/img/step-3-b44a32c7.png";